
import React, {Component} from 'react';
import { Badge, Row, Col, InputGroup, InputGroupAddon, InputGroupButton,  Fade, Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, 
  Card, CardBody, Form, FormGroup,  FormFeedback } from 'reactstrap';


import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Icon from '@material-ui/core/Icon';
import GroupIcon from '@material-ui/icons/ShortText';
import NavigationIcon from '@material-ui/icons/Navigation';
import Sternenbewertung from './Sternenbewertung';
import OffeneFragen from './OffeneFragen';
import TextField from '@material-ui/core/TextField';
import CheckBoxTrueFalse from './CheckBoxTrueFalse';


const styles = theme => ({
    fab: {
      margin: theme.spacing.unit,
    },
    extendedIcon: {
      marginRight: theme.spacing.unit,
    },
  });
  
  class MultiSelectView extends Component {
    constructor(props) {
      super(props);
      this.state = {
      
      };
  
      this.msCallback = this.msCallback.bind(this)
  
    }


    msCallback(element){ // element holds { questionindex, value}

      this.props.callback({index: this.props.index, subitemindex: element.index, val: element.val})

    }

    render() {
    return (
      <div>
        <Container>          
          {this.props.answers && this.props.answers.length > 0 ? this.props.answers.map( (answer, i, arr) =>
                <div>
                               
                <CheckBoxTrueFalse text={answer.value} index={answer.index} callback={this.msCallback}/>
                { arr.length -1 === i ? null : <hr/>}
                </div>
          )

          
            : null
          }

        </Container>
      </div>
    );
    }

}

export default withStyles(styles)(MultiSelectView);


// WEBPACK FOOTER //
// ./src/modules/movie-browser/MultiSelectView.js